import CustomStepper2Step from "components/ui-component/CustomStepper2Step";
import InputField from "components/ui-component/InputField";
import useOutsideClick from "hooks/useOutsideClick";
import React, { useEffect, useRef, useState } from "react";
import { dateToString } from "utils/DateFormat";
import { getScheduleEndDateLimit } from "utils/updatePaymentPlanUtils";
import CalendarIcon from "../../icons/dashboard/Calendar";
import CustomCalender from "components/calender/CustomCalender";
import InputSelect from "components/ui-component/InputSelect";
import {
  cardToShortname,
  checkBankManualFormOrPlaid,
  checkOverPaymentAmount,
  findObjectByValue,
  numberOfTransactions,
} from "utils/HelperFunctions";
import TabsComp from "components/ui-component/Tabs";
import CustomTable1 from "components/ui-component/CustomeTable1";
import { PaypalIcon } from "icons/dashboard/paypal";
import { CashAppIcon } from "icons/dashboard/cashAppIcon";
import { AddCircleIconBlue, EyeIconBlue } from "utils/icon";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  duplicatePaymentGet,
  getpaymentPermission,
  resetCheckDuplicatePayment,
  resetDuplicateOrder,
  setIsPaymentProcessing,
} from "store/slices/paymentsSlice";
import { useUserData } from "store/slices/authSlice";
import { CardIcon } from "icons/payments/Card";
import { BankIconSm } from "icons/payments/BankIconSm";
import Stepper from "components/ui-component/Stepper";
import WalletIcon from "icons/payments/WalletIcon";
import SchedulePaymentComp from "./SchedulePaymentComp";
import CustomAmountInput from "components/ui-component/CustomAmountInput";
import DisclosureFinal from "./DisclosureFinal";
import AmazonPay from "icons/dashboard/AmazonPay";
import { useParams } from "react-router-dom";
import { decode } from "utils/HelperFunctions";
import { usePortalSettingsData } from "store/slices/dashboardSlice";
import {
  useBankData,
  useCardData,
  useOldWalletData,
} from "store/slices/paymentMethodSlice";
import {
  FormRef,
  OverPaymentProtectionEnum,
  PaymentGateway,
  PaymentMethodList,
  SettingsValue,
} from "types/payments";
import {
  onSetFinalDisclosureLoading,
  onSetShowDisclosure,
  updateCheckAmountState,
  updateShowOverlayState,
  useShowFinalDisclosure,
} from "store/slices/commonSlice";
import { useMediaQuery } from "react-responsive";
import CustomModal from "components/ui-component/CustomModal";
import CustomTooltip from "components/ui-component/CustomTooltip";
import { InfoIcon } from "icons/payments/InfoIcon";
import { RootState } from "store/store";
import {
  TabItem,
  ScheduleAmountItem,
  PlaidBankDetails,
  MakePaymentData,
  SchedulePaymentProps,
} from "./types";

const SchedulePayment = ({
  currentStep,
  completedSteps,
  setIsStartDate,
  data,
  isStartDate,
  setData,
  setIsApiCall,
  handleDebouncedChange,
  setDataPayment,
  dataPayment,
  addNewRow,
  removeRow,
  handleChange,
  handleSave,
  isLoading,
  accountLeadData,
  setCurrentStep,
  setCompletedSteps,
  isDataLoading,
  makePayment = false,
  handlePrev,
  setSavedCardsEmail,
  setShowPreview,
  handleGooglePay,
  createPayPalIntent,
  isGoogleLoading = false,
  setIsAddNewCard = () => {},
  isAddNewCard = false,
  setIsConfirmButtonDisable = () => {},
  isSelectedOffer = false,
  handleApplePay = async () => {},
  setHideButtons = () => {},
  setFailedReason,
  setPaymentProcess,
  setAmount,
  sendEmail,
  setScheduleDate,
  setInvoiceId,
  handleSchedulePaymentCreate = async () => {},
  setIsSelectStartDate,
  generalMarkers,
  setIsGoogleLoading,
  activeOffer = "",
  vdcId,
  amount = 0,
  setScheduleMethod = () => {},
  dateErrMsg,
  isEndDateError,
  setDateErrMsg,
  amountValidationError = null,
  amountLimitBalance,
  onScheduleAmountChange = () => {},
}: SchedulePaymentProps) => {
  const portalSettingsData = usePortalSettingsData();
  const [selectedMethod, setSelectedMethod] = useState<
    "Card" | "Bank" | "PayPal" | "Cash App Pay" | string
  >("Card");
  const isLessThan769 = useMediaQuery({ query: "(max-width: 769px)" });
  const { clusterId: cluster_id } = useParams();
  const clusterId = decode(cluster_id || "", true);
  const oldCardData = useCardData();
  const oldBankData = useBankData();
  const oldWalletList = useOldWalletData();
  const portalSettings = usePortalSettingsData();
  const showFinalDisclosure = useShowFinalDisclosure();
  const disclosureContainerRef = useRef<HTMLDivElement>(null);
  const stepperContainerRef = useRef<HTMLDivElement>(null);
  const previousStepRef = useRef(currentStep);
  const pendingDisclosureScrollRef = useRef<boolean>(false);
  const calenderRef = useRef<any>();
  const cashAppRef = useRef<FormRef>(null);
  const bankRef = useRef<FormRef>(null);
  const cardRef = useRef<FormRef>(null);
  const amazonRef = useRef<FormRef>(null);
  const [isTableExpanded, setIsTableExpanded] = useState<boolean>(false);
  const [paymentMethodList, setPaymentMethodList] = useState<
    PaymentMethodList[]
  >([]);
  const [openCalendar, setOpenCalendar] = useState<boolean>(false);

  const [tokenData, setTokenData] = useState<any>(null);
  const [isManualForm, setIsManualForm] = useState<boolean>(true);
  const [isStartDateError, setIsStartDateError] = useState<boolean>(false);

  const scrollToDisclosure = () => {
    let parent = disclosureContainerRef.current?.parentElement;

    while (parent) {
      if (parent.scrollHeight > parent.clientHeight) {
        parent.scrollTo({ top: 0, behavior: "auto" });
      }
      parent = parent.parentElement;
    }

    if (disclosureContainerRef.current) {
      disclosureContainerRef.current.scrollIntoView({
        behavior: "auto",
        block: "start",
      });
      return;
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToStepper = () => {
    if (stepperContainerRef.current) {
      stepperContainerRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      return;
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    if (showFinalDisclosure && pendingDisclosureScrollRef.current) {
      pendingDisclosureScrollRef.current = false;
      requestAnimationFrame(() => {
        scrollToDisclosure();
      });
      window.setTimeout(scrollToDisclosure, 100);
    }
  }, [showFinalDisclosure]);

  useEffect(() => {
    const stepChanged = previousStepRef.current !== currentStep;
    previousStepRef.current = currentStep;

    if (!showFinalDisclosure && stepChanged) {
      requestAnimationFrame(() => {
        scrollToStepper();
      });
    }
  }, [currentStep, showFinalDisclosure]);

  // Track if form has been modified
  const [isScheduleDirty, setIsScheduleDirty] = useState<boolean>(false);

  // Use the confirm leave hook to warn users about unsaved changes
  // useConfirmLeave(isScheduleDirty, "You have unsaved changes. Are you sure you want to leave?");

  const {
    paymentPermission,
    payPalOrder,
    isDuplicateOrders,
    duplicateOrdersCount,
    checkedDuplicatePayment,
    conFee,
  } = useAppSelector((state: RootState) => state.payment);
  const { holidayList } = useAppSelector((state: RootState) => state.dashboard);
  const { showOverPaymentOverlay, checkAmount } = useAppSelector(
    (state: RootState) => state.common
  );
  const userData = useUserData();

  const dispatch = useAppDispatch();
  const [amtErr, setAmtErr] = useState<string | null>(null);
  const displayedAmountError = amtErr || amountValidationError;
  const [startDateErr, setDateErr] = useState<boolean>(false);
  const defaultPaymentMethodList = [
    {
      name: "Card",
      icon: <CardIcon />,
    },
    {
      name: "Bank",
      icon: <BankIconSm />,
    },
  ];

  const Tabs: TabItem[] = [
    {
      name: "Daily",
      value: "daily",
    },
    {
      name: "Weekly",
      value: "weekly",
    },
    {
      name: "Bi-weekly",
      value: "biweekly",
    },
    {
      name: "Monthly",
      value: "monthly",
    },
    {
      name: "Bi-monthly",
      value: "bimonthly",
    },
    {
      name: "Quarterly",
      value: "quarterly",
    },
    {
      name: "Semi-annually",
      value: "biannually",
    },
    {
      name: "Annually",
      value: "annually",
    },
    {
      name: "Custom",
      value: "custom",
    },
  ];

  const ScheduleAmountList: ScheduleAmountItem[] = [
    {
      name: "Fixed",
      value: "fixed",
      isdisabled: makePayment
        ? isSelectedOffer
          ? true
          : false
        : makePayment
          ? data.paymentPlan?.schedule_amount?.toLowerCase() === "fixed"
            ? false
            : true
          : false,
    },
    {
      name: "Auto",
      value: "auto",
      isdisabled:
        userData?.data?.accountData?.balance <= 0
          ? true
          : makePayment
            ? false
            : makePayment
              ? data.paymentPlan?.schedule_amount?.toLowerCase() === "auto"
                ? false
                : true
              : false,
    },
    {
      name: "Custom",
      value: "custom",
      isdisabled: isSelectedOffer ? true : false,
    },
  ];

  const ScheduleAmountTabs: TabItem[] = [
    {
      name: "Amount",
      value: "amount",
    },
    {
      name: "Percent",
      value: "percent",
    },
  ];
  const transactionTypeValue =
    data.paymentPlan?.transaction_type ||
    (`${data.paymentPlan?.transactions?.[0]?.amount_type || ""}`.toUpperCase() ===
    "P"
      ? "percent"
      : "amount");
  const selected =
    findObjectByValue(ScheduleAmountTabs, transactionTypeValue) ||
    ScheduleAmountTabs[0];

  const getPaymentMethodPermission = async (): Promise<void> => {
    try {
      const payload = {
        accountid: userData?.data?.accountData?.accountid,
        clusterid: clusterId,
        lead_id: accountLeadData?.lead_id,
      };
      await dispatch(getpaymentPermission(payload));
    } catch (error) {
      console.error("getPaymentMethodPermission error:", error);
    }
  };

  useEffect(() => {
    if (Object.keys(paymentPermission).length === 0) {
      getPaymentMethodPermission();
    }
  }, []);

  useEffect(() => {
    if (paymentPermission) {
      let methodList = [];

      if (paymentPermission.cc_ext_availability === SettingsValue.YES) {
        methodList.push({
          name: "Card",
          icon: <CardIcon />,
        });
      }

      if (paymentPermission.ach_ext_availability === SettingsValue.YES) {
        methodList.push({
          name: "Bank",
          icon: <BankIconSm />,
        });
      }

      if (
        paymentPermission.pp_ext_availability === SettingsValue.YES &&
        paymentPermission?.pp_gateway_name?.name !== PaymentGateway.STAX
      ) {
        methodList.push({
          name: "PayPal",
          icon: <PaypalIcon />,
        });
      }

      if (paymentPermission.capp_ext_availability === SettingsValue.YES) {
        methodList.push({
          name: "Cash App Pay",
          icon: <CashAppIcon />,
        });
      }

      if (paymentPermission.amzp_ext_availability === SettingsValue.YES) {
        methodList.push({
          name: "Amazon Pay",
          icon: <AmazonPay />,
        });
      }
      if (paymentPermission.cc_ext_availability === SettingsValue.NO) {
        setSelectedMethod(methodList?.[0]?.name);
      }
      setPaymentMethodList(methodList);
    } else {
      setPaymentMethodList(defaultPaymentMethodList);
    }
  }, [paymentPermission]);

  useOutsideClick(calenderRef, () => {
    // setOpenCalendar(false);
    // setIsSelectStartDate(false);
  });

  const handleOnClick = (step: number) => {
    if (step < currentStep) {
      setCurrentStep(step);
      setCompletedSteps(Array.from({ length: step }, (_, i) => i));
    } else {
      return;
    }
  };

  const handleAccept = async (): Promise<void> => {
    dispatch(setIsPaymentProcessing(true));
    await dispatch(onSetFinalDisclosureLoading(true));
    try {
      if (isAddNewCard) {
        await handleSchedulePaymentCreate?.({});
        // Reset form dirty state after successful submission
        setIsScheduleDirty(false);
      } else {
        switch (selectedMethod) {
          case "Card":
            if (
              paymentPermission?.cc_gateway_name?.name ===
                PaymentGateway.STRIPE &&
              cardRef.current
            ) {
              await cardRef.current.callHandleClick();
              // Reset form dirty state after successful submission
              setIsScheduleDirty(false);
            } else {
              await handleSchedulePaymentCreate({});
              // Reset form dirty state after successful submission
              setIsScheduleDirty(false);
            }
            break;
          case "Amazon Pay":
            if (amazonRef.current) {
              await amazonRef.current.callHandleClick();
              // Reset form dirty state after successful submission
              setIsScheduleDirty(false);
            } else {
              await handleSchedulePaymentCreate({});
              // Reset form dirty state after successful submission
              setIsScheduleDirty(false);
            }
            break;
          case "Bank":
            let check = checkBankManualFormOrPlaid({
              manual_ach: portalSettings?.manual_ach,
              validate_bank_account: portalSettings?.validate_bank_account,
              isManualForm,
            });
            if (
              (paymentPermission?.ach_gateway_name?.name ===
                PaymentGateway.STRIPE ||
                check) &&
              bankRef.current
            ) {
              await bankRef.current.callHandleClick();
              // Reset form dirty state after successful submission
              setIsScheduleDirty(false);
            } else {
              await handleSchedulePaymentCreate({});
              // Reset form dirty state after successful submission
              setIsScheduleDirty(false);
            }
            break;
          case "Cash App Pay":
            if (cashAppRef.current) {
              await cashAppRef.current.callHandleClick();
              // Reset form dirty state after successful submission
              setIsScheduleDirty(false);
            }
            break;
          case "PayPal":
            if (
              (portalSettings?.payment_agreement_opt === SettingsValue.CUSTOM ||
                portalSettings?.payment_agreement_opt ===
                  SettingsValue.DEFAULT) &&
              !showFinalDisclosure
            ) {
              dispatch(resetDuplicateOrder());
              dispatch(onSetFinalDisclosureLoading(false));
              pendingDisclosureScrollRef.current = true;
              dispatch(onSetShowDisclosure(true));
              setHideButtons(true);
            } else {
              dispatch(updateCheckAmountState(false));
              window.location.href = payPalOrder.url;
            }
            break;
          case "Wire":
            await handleSchedulePaymentCreate({});
            // Reset form dirty state after successful submission
            setIsScheduleDirty(false);
            break;
          case "Google Pay":
            await handleGooglePayPayment(
              tokenData?.token,
              tokenData?.total_amount
            );
            // Reset form dirty state after successful submission
            setIsScheduleDirty(false);
            break;
          case "Apple Pay":
            await handleApplePay(
              tokenData?.success,
              tokenData?.token,
              tokenData?.failureMessage
            );
            setIsScheduleDirty(false);
            break;
          default:
            console.log("selectedMethod =====", selectedMethod);
        }
      }
    } catch (error) {
      console.log("handleAccept error =====", error);
    } finally {
      dispatch(setIsPaymentProcessing(false));
    }
  };

  const getStartLimit = (): Date => {
    const current = portalSettingsData?.start_date_limit_external;
    const currentArr = current?.split("-");
    if (currentArr?.length === 2) {
      let days = Number(currentArr[0]);

      if (currentArr[1] === "W") {
        days = days * 7;
      }

      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + days);

      return currentDate;
    } else {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 365);

      return currentDate;
    }
  };

  const getEndLimit = () => {
    const configuredLimit = portalSettingsData?.end_date_limit_external?.trim();

    // With no portal setting, scheduling is intentionally uncapped. Passing
    // `undefined` lets the calendar show dates beyond the former one-year cap.
    return configuredLimit
      ? getScheduleEndDateLimit(configuredLimit)
      : undefined;
  };

  const handlePlaidBankPayment = async (
    values: any,
    isCCTokenAvailable: boolean = false
  ): Promise<void> => {
    try {
      const payload: PlaidBankDetails = {
        x_payment_method: "ACH",
        email: values?.email || "",
        bankName: values?.bankName || "",
        bank_name: values?.bankName || "",
        bank: values?.bank || "",
        choldername: values?.choldername || "",
        x_city: values?.x_city || "",
        x_address: values?.x_address || "",
        address2: values?.address2 || "",
        x_zip: values?.x_zip || "",
        x_state: values?.x_state || "",
        x_country: values?.x_country || "",
        routing_number: values?.routing_number || "",
        account_number: values?.account_number || "",
        gateway_id: values?.gateway_id || 0,
        gateway_name: values?.gateway_name || "",
        default: "N",
        cc_token: values?.cc_token || "",
        cc_token2: values?.cc_token2 || "",
        stripe_token: values?.cc_token || "",
        pc_atid: values?.pc_atid || 0,
        cppid: values?.cppid || 0,
      };
      await handleSchedulePaymentCreate?.({
        isPlaid: true,
        isCCTokenAvailable,
        plaidBankDetails: payload,
      });
      // Reset form dirty state after successful submission
      setIsScheduleDirty(false);
    } catch (error) {
      console.error("handlePlaidBankPayment error:", error);
    }
  };

  const checkPastAmount = async (method?: string): Promise<boolean> => {
    try {
      const payload = {
        accounts_id: userData?.data?.accountData?.id,
        payment_method: method ? method : cardToShortname(selectedMethod),
        amount: Number(amount) + conFee,
      };
      const res: any = await dispatch(duplicatePaymentGet(payload)).unwrap();
      const { isDuplicateOrders, duplicateOrdersCount } = res?.body?.data;
      if (isDuplicateOrders && duplicateOrdersCount > 0) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.error("checkPastAmount error:", error);
      return true; // Default to allowing payment on error
    }
  };

  const handleGooglePayPayment = async (
    tokenData: any,
    amount: number
  ): Promise<void> => {
    console.info("[Stripe Google Pay][schedule] payment received", {
      hasIntent: Boolean(tokenData?.id),
      intentType: tokenData?.id?.split("_")?.[0] || "legacy",
      paymentMethod: "GP",
    });
    setScheduleMethod("GP");
    setIsGoogleLoading(true);
    const negativeBalance = !checkAmount
      ? await checkOverPaymentAmount({
          amount: Number(amount),
          balance: userData?.data?.accountData?.balance,
          overpayment_protection: portalSettings?.overpayment_protection,
          dispatch,
        })
      : true;
    if (!negativeBalance) {
      setIsGoogleLoading(false);
      return;
    }
    const moveAhead = !checkedDuplicatePayment
      ? await checkPastAmount("GP")
      : true;
    try {
      if (!moveAhead) {
        dispatch(onSetFinalDisclosureLoading(false));
        setSelectedMethod("Google Pay");
        setIsGoogleLoading(false);
        setTokenData({ token: tokenData, total_amount: amount });
      } else {
        if (
          (portalSettings?.payment_agreement_opt === SettingsValue.CUSTOM ||
            portalSettings?.payment_agreement_opt === SettingsValue.DEFAULT) &&
          !showFinalDisclosure
        ) {
          setSelectedMethod("Google Pay");
          setTokenData({ token: tokenData, total_amount: amount });
          setIsGoogleLoading(false);
          dispatch(onSetFinalDisclosureLoading(false));
          dispatch(resetDuplicateOrder());
          pendingDisclosureScrollRef.current = true;
          dispatch(onSetShowDisclosure(true));
        } else {
          dispatch(resetDuplicateOrder());
          dispatch(resetCheckDuplicatePayment());
          dispatch(updateCheckAmountState(false));
          if (handleGooglePay) {
            console.info("[Stripe Google Pay][schedule] forwarding payment", {
              hasIntent: Boolean(tokenData?.id),
              paymentMethod: "GP",
            });
            await handleGooglePay(tokenData, amount);
          }
        }
      }
    } catch (error) {
      console.log("handleGooglePayPayment error =====", error);
    }
  };

  const handleApplePayPayment = async (
    success: boolean,
    paymentIntent: any,
    failureMessage?: string
  ): Promise<void> => {
    console.info("[Stripe Apple Pay][schedule] payment received", {
      hasIntent: Boolean(paymentIntent?.id),
      intentType: paymentIntent?.id?.split("_")?.[0] || "missing",
      paymentMethod: "AP",
      success,
    });
    setScheduleMethod("AP");

    if (!success || !paymentIntent?.id) {
      await handleApplePay(success, paymentIntent, failureMessage);
      return;
    }

    const negativeBalance = !checkAmount
      ? await checkOverPaymentAmount({
          amount: Number(amount),
          balance: userData?.data?.accountData?.balance,
          overpayment_protection: portalSettings?.overpayment_protection,
          dispatch,
        })
      : true;
    if (!negativeBalance) return;

    const moveAhead = !checkedDuplicatePayment
      ? await checkPastAmount("AP")
      : true;
    const pendingApplePay = {
      success,
      token: paymentIntent,
      total_amount: amount,
      failureMessage,
    };

    if (!moveAhead) {
      dispatch(onSetFinalDisclosureLoading(false));
      setSelectedMethod("Apple Pay");
      setTokenData(pendingApplePay);
      return;
    }

    if (
      (portalSettings?.payment_agreement_opt === SettingsValue.CUSTOM ||
        portalSettings?.payment_agreement_opt === SettingsValue.DEFAULT) &&
      !showFinalDisclosure
    ) {
      setSelectedMethod("Apple Pay");
      setTokenData(pendingApplePay);
      dispatch(onSetFinalDisclosureLoading(false));
      dispatch(resetDuplicateOrder());
      pendingDisclosureScrollRef.current = true;
      dispatch(onSetShowDisclosure(true));
      return;
    }

    dispatch(resetDuplicateOrder());
    dispatch(resetCheckDuplicatePayment());
    dispatch(updateCheckAmountState(false));
    await handleApplePay(success, paymentIntent, failureMessage);
  };

  return (
    <>
      <div
        ref={stepperContainerRef}
        className="h-0"
        style={{ scrollMarginTop: "84px" }}
      />

      <div
        className={`${
          showFinalDisclosure ? `hidden none` : ""
        } lg:h-full w-full`}
      >
        {/* The column below is `relative` so the schedule table's bottom alerts
            can centre on it rather than on the viewport. They sit inside an
            overflow-x-scroll wrapper, but an absolutely positioned box whose
            containing block is above that scroller escapes its clipping. */}
        {!isLessThan769 && (
          <div className="relative gap-7 pb-[76px] lg:flex hidden h-full w-full">
            <div className="w-[10%] flex h-full">
              <CustomStepper2Step
                currentStep={currentStep}
                completedSteps={completedSteps}
                className="!h-[42px]"
                handleOnClick={handleOnClick}
              />
            </div>
            <div className={`w-[90%]`}>
              {/* SCHDULE PAYMENT  */}
              <div className="">
                <p
                  className={`${
                    currentStep === 1
                      ? "text-btnPrimaryActive"
                      : "text-txtPrimary"
                  } text-xl`}
                >
                  Schedule payment
                </p>
                {/* Both scroll wrappers clip at the column's left edge, which is
                    also the start-date calendar's left edge — so its shadow was
                    cut off on that side. Pull the clipping edge 20px left and
                    pad the content back so nothing else moves. */}
                <div
                  className={`answerSection2 ${
                    currentStep === 1 ? "open" : ""
                  } -ml-5 pl-5`}
                >
                  {/* pr-3 keeps the full-width frequency tabs clear of the
                      8px scrollbar instead of butting against it. */}
                  <div className="overflow-x-scroll h-full -ml-5 pl-5 pr-3">
                    <div className="w-full h-full lg:min-w-[600px]">
                      <div
                        className={`w-full h-fit ${!isTableExpanded ? "" : "hidden"}`}
                      >
                        <div className="flex mt-[24px] gap-x-[20px]">
                          {/* CALENDER */}
                          <div
                            ref={calenderRef}
                            className={`${
                              data.agreementType === "present" ||
                              isSelectedOffer
                                ? "cursor-not-allowed"
                                : "cursor-pointer"
                            } relative`}
                          >
                            <div
                              className="relative"
                              onClick={(e: any) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (!isSelectedOffer) {
                                  setOpenCalendar(!openCalendar);
                                  setIsStartDate(!isStartDate);
                                }
                              }}
                            >
                              <div
                                key={dateToString(
                                  data?.paymentPlan?.transactions?.[0]
                                    ?.payment_date ??
                                    data?.paymentPlan?.transactions?.[0]
                                      ?.billing_date ??
                                    data.paymentPlan.start_date
                                )}
                                className="animate__animated animate__fadeIn animate__faster"
                                onAnimationEnd={(e) =>
                                  e.currentTarget.classList.remove(
                                    "animate__animated",
                                    "animate__fadeIn",
                                    "animate__faster"
                                  )
                                }
                              >
                                <InputField
                                  label="start date"
                                  disabled={isSelectedOffer}
                                  placeholder="01/23/2023"
                                  value={dateToString(
                                    data?.paymentPlan?.transactions?.[0]
                                      ?.payment_date ??
                                      data?.paymentPlan?.transactions?.[0]
                                        ?.billing_date ??
                                      data.paymentPlan.start_date
                                  )}
                                  noLabel={false}
                                  _className="hover:!border-strokeActive"
                                />
                              </div>
                              <span className="absolute right-[15px] bottom-[12px]">
                                <CalendarIcon />
                              </span>
                            </div>

                            {openCalendar && (
                              <>
                                <CustomCalender
                                  isDashFormat={true}
                                  value={data.paymentPlan.start_date}
                                  disableTiles={holidayList}
                                  minDate={new Date()}
                                  maxDate={getStartLimit()}
                                  openCalendar={openCalendar}
                                  setOpenCalendar={setOpenCalendar}
                                  onChange={(date: any) => {
                                    dispatch(setIsPaymentProcessing(true));
                                    setOpenCalendar(false);
                                    setIsStartDate(false);
                                    setIsSelectStartDate(true);
                                    const tmp: any = { ...data.paymentPlan };
                                    tmp.start_date = moment(
                                      dateToString(date)
                                    ).format("MM/DD/YYYY");
                                    setData({
                                      ...data,
                                      paymentPlan: tmp,
                                    });
                                    // Mark form as dirty when user makes changes
                                    if (!isScheduleDirty) {
                                      setIsScheduleDirty(true);
                                    }
                                    setIsApiCall(true);
                                  }}
                                />
                              </>
                            )}
                          </div>

                          {/* SELECT */}
                          <div
                            className={`w-[178px] ${
                              data.agreementType === "present"
                                ? "pointer-events-none"
                                : "pointer-events-auto"
                            }`}
                          >
                            <InputSelect
                              isSearchFeature
                              searchFieldType="number"
                              labelPlaceHolder=""
                              label="number of transactions"
                              disabled={isSelectedOffer}
                              value={String(
                                data.paymentPlan?.no_of_transaction || 1
                              )}
                              options={numberOfTransactions(
                                portalSettings?.transaction_limit || 15
                              )}
                              selected={findObjectByValue(
                                numberOfTransactions(
                                  portalSettings?.transaction_limit
                                ),
                                data.paymentPlan?.no_of_transaction || 1
                              )}
                              setSelected={(val: any) => {
                                dispatch(setIsPaymentProcessing(true));
                                const tmp = { ...data.paymentPlan };
                                tmp.no_of_transaction = val.value;
                                setData({
                                  ...data,
                                  paymentPlan: tmp,
                                } as any);
                                // Mark form as dirty when user makes changes
                                if (!isScheduleDirty) {
                                  setIsScheduleDirty(true);
                                }
                                setIsApiCall(true);
                              }}
                              isSelectedOffer={isSelectedOffer}
                            />
                          </div>
                        </div>

                        {/* TABS */}
                        <div
                          className={`h-[40px] mt-[16px] ${
                            data.agreementType === "present"
                              ? "pointer-events-none"
                              : "pointer-events-auto"
                          }`}
                        >
                          <TabsComp
                            disableHover={isSelectedOffer}
                            totalTabs={Tabs}
                            selected={findObjectByValue(
                              Tabs,
                              data.paymentPlan?.schedule_fld || "daily"
                            )}
                            setSelected={(val: any) => {
                              dispatch(setIsPaymentProcessing(true));
                              const tmp = { ...data.paymentPlan };
                              tmp.schedule_fld = val.value;
                              setData({ ...data, paymentPlan: tmp });
                              // Mark form as dirty when user makes changes
                              if (!isScheduleDirty) {
                                setIsScheduleDirty(true);
                              }
                              setIsApiCall(true);
                            }}
                          />
                        </div>

                        {/* SECTION3 */}
                        <div className="mt-[24px] flex gap-x-[20px]">
                          {/* SELECT */}
                          <div
                            className={`w-[180px] ${
                              data.agreementType === "present" ||
                              data.isOfferEnabled
                                ? "pointer-events-none"
                                : "pointer-events-auto"
                            }`}
                          >
                            <InputSelect
                              label="Schedule Amount"
                              labelPlaceHolder="Schedule Amount"
                              defaultValue="Fixed"
                              disabled={!makePayment}
                              isInfoAvailable={true}
                              infoText="Define how you want the amount per transaction to be calculated."
                              infoClassName="w-[220px]"
                              value={data.paymentPlan?.schedule_amount}
                              options={ScheduleAmountList}
                              selected={findObjectByValue(
                                ScheduleAmountList,
                                data.paymentPlan?.schedule_amount
                              )}
                              setSelected={(val: any) => {
                                dispatch(setIsPaymentProcessing(true));
                                if (makePayment) {
                                  setIsApiCall(true);
                                  const tmp = { ...data.paymentPlan };
                                  tmp.schedule_amount = val.value;
                                  // Changing the schedule-amount mode resets
                                  // the transaction-type tab to "Amount", so
                                  // the stale Custom/Percent state must be
                                  // cleared or it gets submitted later.
                                  tmp.transaction_type = "amount";
                                  tmp.percentage_amounts = [];
                                  setData({ ...data, paymentPlan: tmp });
                                  // Mark form as dirty when user makes changes
                                  if (!isScheduleDirty) {
                                    setIsScheduleDirty(true);
                                  }
                                  if (val.value === "custom") {
                                    const tmp = { ...data.paymentPlan };
                                    tmp.schedule_amount = val.value;
                                    // Changing the schedule-amount mode resets
                                    // the transaction-type tab to "Amount", so
                                    // the stale Custom/Percent state must be
                                    // cleared or it gets submitted later.
                                    tmp.transaction_type = "amount";
                                    tmp.percentage_amounts = [];
                                    setData({ ...data, paymentPlan: tmp });
                                  }
                                } else {
                                  if (makePayment) {
                                    if (val.value === "custom") {
                                      // setIsApiCall(true);
                                      const tmp = { ...data.paymentPlan };
                                      tmp.schedule_amount = val.value;
                                      // Changing the schedule-amount mode resets
                                      // the transaction-type tab to "Amount", so
                                      // the stale Custom/Percent state must be
                                      // cleared or it gets submitted later.
                                      tmp.transaction_type = "amount";
                                      tmp.percentage_amounts = [];
                                      setData({ ...data, paymentPlan: tmp });
                                      // Mark form as dirty when user makes changes
                                      if (!isScheduleDirty) {
                                        setIsScheduleDirty(true);
                                      }
                                    }
                                  } else {
                                    setIsApiCall(true);
                                    const tmp = { ...data.paymentPlan };
                                    tmp.schedule_amount = val.value;
                                    // Changing the schedule-amount mode resets
                                    // the transaction-type tab to "Amount", so
                                    // the stale Custom/Percent state must be
                                    // cleared or it gets submitted later.
                                    tmp.transaction_type = "amount";
                                    tmp.percentage_amounts = [];
                                    setData({ ...data, paymentPlan: tmp });
                                    // Mark form as dirty when user makes changes
                                    if (!isScheduleDirty) {
                                      setIsScheduleDirty(true);
                                    }
                                  }
                                }
                              }}
                              makePayment
                              isSelectedOffer={isSelectedOffer}
                            />
                          </div>
                          {data.paymentPlan?.schedule_amount === "custom" ? (
                            <div className="w-[180px]">
                              <div
                                className={`flex gap-x-[5px] mb-[3px] leading-[15.62px]`}
                              >
                                <p className="text-xs uppercase font-bold text-txtSecondary">
                                  transaction type
                                </p>
                                <CustomTooltip
                                  maxwidth="430px"
                                  place="top"
                                  id={`transaction-type-anchor`}
                                  content={`<div class="text-xs leading-[18px] font-normal max-w-[200px]">You can either enter an amount or select a percentage of the total amount for each transaction.</div>`}
                                >
                                  <InfoIcon
                                    id={`transaction-type-anchor`}
                                    strokeColor="var(--color-icon-bright)"
                                    className="cursor-pointer group"
                                    _className="group-hover:!stroke-iconObscure"
                                  />
                                </CustomTooltip>
                              </div>
                              <div className="h-[40px]">
                                <TabsComp
                                  totalTabs={ScheduleAmountTabs}
                                  selected={selected}
                                  setSelected={(val: any) => {
                                    dispatch(setIsPaymentProcessing(true));
                                    if (makePayment) {
                                      const tmp = { ...data.paymentPlan };
                                      tmp.transaction_type = val.value;
                                      if (val.value !== selected.value) {
                                        let updatedTransArr =
                                          tmp.transactions?.map(
                                            (item: any) => ({
                                              ...item,
                                              amount: 0,
                                            })
                                          ) || [];
                                        tmp.transactions = updatedTransArr;
                                        tmp.percentage_amounts = [];
                                      }
                                      setData({ ...data, paymentPlan: tmp });
                                      setIsApiCall(true);
                                      // Mark form as dirty when user makes changes
                                      if (!isScheduleDirty) {
                                        setIsScheduleDirty(true);
                                      }
                                    }
                                  }}
                                  isInfo
                                />
                              </div>
                            </div>
                          ) : (
                            <div>
                              <div
                                className={`flex gap-x-[5px]  mb-[3px] items-center leading-[15.62px]`}
                              >
                                <p className="text-xs uppercase font-bold text-txtSecondary">
                                  transaction amount
                                </p>
                                <CustomTooltip
                                  maxwidth="430px"
                                  place="top"
                                  id={`transaction-amount-anchor`}
                                  content={`<div class="text-xs leading-[18px] font-normal max-w-[410px]">${
                                    data.paymentPlan?.schedule_amount ===
                                    "fixed"
                                      ? "Define a fixed amount per transaction."
                                      : "The amount shown is automatically calculated by dividing the customer’s current balance by the total number of transactions. To change the transaction amount, select ‘Fixed’ or ‘Custom’."
                                  }</div>`}
                                >
                                  <InfoIcon
                                    id={`transaction-amount-anchor`}
                                    strokeColor="var(--color-icon-bright)"
                                    className="cursor-pointer group"
                                    _className="group-hover:!stroke-iconObscure"
                                  />
                                </CustomTooltip>
                              </div>
                              <div
                                className={`relative max-w-[187px] ${
                                  data.agreementType === "present"
                                    ? "pointer-events-none"
                                    : "pointer-events-auto"
                                }`}
                              >
                                <CustomAmountInput
                                  inputValue={
                                    data?.paymentPlan.schedule_amount === "auto"
                                      ? data?.paymentPlan?.transactions?.[0]
                                          ?.amount
                                      : data?.paymentPlan?.amount
                                  }
                                  readOnly={isSelectedOffer}
                                  aria-readonly={isSelectedOffer}
                                  aria-label={
                                    isSelectedOffer
                                      ? "Transaction amount, set by selected offer"
                                      : "Transaction amount"
                                  }
                                  disabled={
                                    !isSelectedOffer &&
                                    data?.paymentPlan?.schedule_amount ===
                                      "auto"
                                  }
                                  setinputValue={(
                                    val: any,
                                    validationError?: string | null
                                  ) => {
                                    if (isSelectedOffer) return;
                                    onScheduleAmountChange();
                                    const tmp = { ...data.paymentPlan };
                                    tmp.amount = val;
                                    setData({ ...data, paymentPlan: tmp });
                                    // Mark form as dirty when user makes changes
                                    if (!isScheduleDirty) {
                                      setIsScheduleDirty(true);
                                    }
                                    if (validationError) {
                                      handleDebouncedChange(false);
                                      return;
                                    }
                                    dispatch(setIsPaymentProcessing(true));
                                    handleDebouncedChange();
                                  }}
                                  balance={
                                    amountLimitBalance ??
                                    userData?.data?.accountData?.balance
                                  }
                                  setErr={setAmtErr}
                                  className={`!pl-[23px] ${
                                    isSelectedOffer
                                      ? "!bg-bgThird cursor-not-allowed"
                                      : ""
                                  }`}
                                  showErr={false}
                                  checkAmt={true}
                                  allowOutOfRange={true}
                                  validateOnChange={true}
                                />
                                {displayedAmountError && (
                                  <p
                                    className="text-red text-xs leading-[18.23px] w-full break-words"
                                    role="alert"
                                  >
                                    {displayedAmountError}
                                  </p>
                                )}
                                {isSelectedOffer && !displayedAmountError && (
                                  <p className="text-txtSecondary text-xs leading-[18.23px] mt-1">
                                    Amount set by the selected offer.
                                  </p>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* TABLE COMPONENT */}
                      <div className="mt-[8px] h-[480px] max-h-[480px]">
                        <CustomTable1
                          dataArr={data?.paymentPlan?.transactions}
                          amountType={selected?.value || "amount"}
                          isExpanded={isTableExpanded}
                          setIsExpanded={setIsTableExpanded}
                          isDateCustom={
                            data.paymentPlan?.schedule_fld === "custom"
                          }
                          isCustom={
                            data.paymentPlan?.schedule_amount?.toLowerCase() ===
                            "custom"
                              ? true
                              : false
                          }
                          isSettlementEnable={data?.isOfferEnabled}
                          totalAmount={data.paymentPlan?.amount_subtotal}
                          grandTotal={data.paymentPlan?.grand_total}
                          addNewRow={addNewRow}
                          removeRow={removeRow}
                          handleChange={handleChange}
                          handleSave={handleSave}
                          isLoading={isLoading}
                          isdisplayFeeColumn={false}
                          makePayment={makePayment}
                          data={data}
                          amtErr={displayedAmountError}
                          amountLimitBalance={amountLimitBalance}
                          getStartLimit={getEndLimit}
                          isStartDateError={isStartDateError}
                          setIsStartDateError={setIsStartDateError}
                          startDateErr={startDateErr}
                          dateErrMsg={dateErrMsg}
                          isEndDateError={isEndDateError}
                          setDateErrMsg={setDateErrMsg}
                          setIsPaymentProcessing={(val) =>
                            dispatch(setIsPaymentProcessing(val))
                          }
                        />
                      </div>
                      {/* Section 1 */}
                    </div>
                  </div>
                </div>
              </div>

              {/* PAYMENT METHOD */}
              <div className={`w-full`}>
                <div className="w-full h-[2px] bg-bgSecondary mt-7"></div>
                <div className="w-full flex justify-between items-center max-w-[510px] xl:flex-nowrap flex-wrap">
                  <p
                    className={`${
                      currentStep === 2
                        ? "text-btnPrimaryActive pt-7"
                        : "text-txtPrimary pt-5"
                    } font-medium text-xl w-fit`}
                  >
                    Payment method
                  </p>
                  {currentStep === 2 && (
                    <div className="xl:w-fit w-full flex gap-3 xl:justify-end justify-between items-center xl:pt-7 pt-2">
                      <div className="flex items-center gap-5 ">
                        <p
                          className="flex gap-2 items-center text-sm text-btnPrimaryActive hover:!text-btnPrimaryHover cursor-pointer"
                          onClick={() => {
                            setScheduleMethod?.(
                              cardToShortname(selectedMethod)
                            );
                            setShowPreview?.(true);
                          }}
                        >
                          <EyeIconBlue /> Preview
                        </p>
                      </div>
                      {isAddNewCard ? (
                        <p
                          onClick={() => setIsAddNewCard(false)}
                          className="flex gap-2 items-center cursor-pointer text-sm text-blue hover:!text-btnPrimaryHover"
                        >
                          <AddCircleIconBlue size="20" /> Add New
                        </p>
                      ) : (
                        (oldCardData?.length > 0 ||
                          oldBankData?.length > 0) && (
                          <p
                            className="xl:text-sm text-xs items-center text-blue cursor-pointer flex gap-2 hover:!text-btnPrimaryHover"
                            onClick={() => setIsAddNewCard(true)}
                          >
                            <span>
                              <WalletIcon
                                className="group"
                                _className="group-hover:!fill-btnPrimaryHover"
                              />
                            </span>
                            Select saved method
                          </p>
                        )
                      )}
                    </div>
                  )}
                </div>

                <div
                  className={`max-w-[510px] w-full answerSection2 ${
                    currentStep === 2 ? "open" : ""
                  } pb-5 `}
                >
                  <SchedulePaymentComp
                    currentStep={2}
                    handlePrev={handlePrev}
                    schedulePayment={true}
                    dataArr={data?.paymentPlan}
                    handleGooglePay={handleGooglePayPayment}
                    createPayPalIntent={createPayPalIntent}
                    isGoogleLoading={isGoogleLoading}
                    paymentMethodList={paymentMethodList}
                    setSavedCardsEmail={setSavedCardsEmail}
                    dataPayment={dataPayment}
                    setDataPayment={setDataPayment}
                    walletList={oldWalletList}
                    isDataLoading={isDataLoading}
                    setCurrentStep={setCurrentStep}
                    setIsAddNewCard={setIsAddNewCard}
                    isAddNewCard={isAddNewCard}
                    setIsConfirmButtonDisable={setIsConfirmButtonDisable}
                    handleApplePay={handleApplePayPayment}
                    setShowPreview={setShowPreview}
                    setScheduleMethod={setScheduleMethod}
                    setHideButtons={setHideButtons}
                    setFailedReason={setFailedReason}
                    setPaymentProcess={setPaymentProcess}
                    setAmount={setAmount}
                    sendEmail={sendEmail}
                    setScheduleDate={setScheduleDate}
                    setInvoiceId={setInvoiceId}
                    cashAppRef={cashAppRef}
                    bankRef={bankRef}
                    cardRef={cardRef}
                    selectedMethod={selectedMethod}
                    setSelectedMethod={setSelectedMethod}
                    amazonRef={amazonRef}
                    handlePlaidBankPayment={handlePlaidBankPayment}
                    isManualForm={isManualForm}
                    setIsManualForm={setIsManualForm}
                    activeOffer={activeOffer}
                    vdcId={vdcId}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {isLessThan769 && (
          <div className="lg:hidden flex flex-col lg:h-full w-full">
            <div className="px-5 py-5 w-full">
              <Stepper
                currentStep={currentStep}
                Steps={2}
                completedSteps={completedSteps}
                handleOnClick={handleOnClick}
              />
            </div>
            <div className="w-full flex lg:h-full flex-col gap-5">
              {/* SCHDULE PAYMENT  */}
              {currentStep === 1 && (
                <>
                  <p className={`px-5  w-full text-blue`}>Schedule payment</p>
                  <div className="px-5  w-full flex justify-between items-center gap-[10px]">
                    <div
                      ref={calenderRef}
                      onClick={() => {
                        if (!isSelectedOffer) {
                          setOpenCalendar(!openCalendar);
                          setIsStartDate(!isStartDate);
                        }
                      }}
                      className={`${
                        data.agreementType === "present" || isSelectedOffer
                          ? "cursor-not-allowed"
                          : "cursor-pointer"
                      } relative w-full`}
                    >
                      <div className="relative">
                        <div
                          key={dateToString(data.paymentPlan.start_date)}
                          className="animate__animated animate__fadeIn animate__faster"
                          onAnimationEnd={(e) =>
                            e.currentTarget.classList.remove(
                              "animate__animated",
                              "animate__fadeIn",
                              "animate__faster"
                            )
                          }
                        >
                          <InputField
                            label="start date"
                            disabled={isSelectedOffer}
                            placeholder="01/23/2023"
                            value={dateToString(data.paymentPlan.start_date)}
                            noLabel={false}
                            _className="hover:!border-strokeActive"
                          />
                        </div>
                        <span className="absolute right-[15px] bottom-[12px]">
                          <CalendarIcon />
                        </span>
                      </div>

                      {openCalendar && (
                        <>
                          <CustomCalender
                            isDashFormat={true}
                            value={data.paymentPlan.start_date}
                            disableTiles={holidayList}
                            minDate={new Date()}
                            maxDate={getStartLimit()}
                            openCalendar={openCalendar}
                            setOpenCalendar={setOpenCalendar}
                            onChange={(date: any) => {
                              setOpenCalendar(false);
                              setIsStartDate(false);
                              setIsSelectStartDate(true);
                              const tmp: any = { ...data.paymentPlan };
                              tmp.start_date = moment(
                                dateToString(date)
                              ).format("MM/DD/YYYY");
                              setData({
                                ...data,
                                paymentPlan: tmp,
                              });
                              setIsApiCall(true);
                            }}
                          />
                        </>
                      )}
                    </div>
                    <div
                      className={`w-full ${
                        data.agreementType === "present"
                          ? "pointer-events-none"
                          : "pointer-events-auto"
                      }`}
                    >
                      <InputSelect
                        isSearchFeature
                        searchFieldType="string"
                        labelPlaceHolder=""
                        label="frequency"
                        disabled={isSelectedOffer}
                        value={data.paymentPlan?.schedule_fld || "daily"}
                        options={Tabs}
                        selected={findObjectByValue(
                          Tabs,
                          data.paymentPlan?.schedule_fld || "daily"
                        )}
                        setSelected={(val: any) => {
                          const tmp = { ...data.paymentPlan };
                          tmp.schedule_fld = val.value;
                          setData({ ...data, paymentPlan: tmp });
                          setIsApiCall(true);
                        }}
                        isSelectedOffer={isSelectedOffer}
                      />
                    </div>
                  </div>
                  <div className="px-5  w-full">
                    <div
                      className={`w-full ${
                        data.agreementType === "present"
                          ? "pointer-events-none"
                          : "pointer-events-auto"
                      }`}
                    >
                      <InputSelect
                        isSearchFeature
                        searchFieldType="number"
                        labelPlaceHolder=""
                        label="number of transactions"
                        disabled={isSelectedOffer}
                        value={String(data.paymentPlan?.no_of_transaction || 1)}
                        options={numberOfTransactions(
                          portalSettings?.transaction_limit || 15
                        )}
                        selected={findObjectByValue(
                          numberOfTransactions(
                            portalSettings?.transaction_limit
                          ),
                          data.paymentPlan?.no_of_transaction || 1
                        )}
                        setSelected={(val: any) => {
                          const tmp = { ...data.paymentPlan };
                          tmp.no_of_transaction = val.value;
                          setData({
                            ...data,
                            paymentPlan: tmp,
                          } as MakePaymentData);
                          setIsApiCall(true);
                        }}
                        isSelectedOffer={isSelectedOffer}
                      />
                    </div>
                  </div>
                  <div className="px-5 w-full flex justify-between items-center gap-[10px]">
                    <div
                      className={`w-full ${
                        data.agreementType === "present" || data.isOfferEnabled
                          ? "pointer-events-none"
                          : "pointer-events-auto"
                      }`}
                    >
                      <InputSelect
                        label="Schedule Amount"
                        labelPlaceHolder="Schedule Amount"
                        defaultValue="Fixed"
                        isInfoAvailable={true}
                        infoText="Define how you want the amount per transaction to be calculated."
                        infoClassName="w-[220px]"
                        disabled={!makePayment}
                        value={data.paymentPlan?.schedule_amount}
                        options={ScheduleAmountList}
                        selected={findObjectByValue(
                          ScheduleAmountList,
                          data.paymentPlan?.schedule_amount
                        )}
                        setSelected={(val: any) => {
                          // Changing the schedule-amount mode resets the
                          // transaction-type tab to "Amount", so the stale
                          // Custom/Percent state must be cleared or it gets
                          // submitted later.
                          if (makePayment) {
                            setIsApiCall(true);
                            const tmp = { ...data.paymentPlan };
                            tmp.schedule_amount = val.value;
                            tmp.transaction_type = "amount";
                            tmp.percentage_amounts = [];
                            setData({ ...data, paymentPlan: tmp });
                            if (val.value === "custom") {
                              const tmp = { ...data.paymentPlan };
                              tmp.schedule_amount = val.value;
                              tmp.transaction_type = "amount";
                              tmp.percentage_amounts = [];
                              setData({ ...data, paymentPlan: tmp });
                            }
                          } else {
                            if (makePayment) {
                              if (val.value === "custom") {
                                // setIsApiCall(true);
                                const tmp = { ...data.paymentPlan };
                                tmp.schedule_amount = val.value;
                                tmp.transaction_type = "amount";
                                tmp.percentage_amounts = [];
                                setData({ ...data, paymentPlan: tmp });
                              }
                            } else {
                              setIsApiCall(true);
                              const tmp = { ...data.paymentPlan };
                              tmp.schedule_amount = val.value;
                              tmp.transaction_type = "amount";
                              tmp.percentage_amounts = [];
                              setData({ ...data, paymentPlan: tmp });
                            }
                          }
                        }}
                        makePayment
                        isSelectedOffer={isSelectedOffer}
                      />
                    </div>
                    {data.paymentPlan?.schedule_amount === "custom" ? (
                      <div className="w-full">
                        <div
                          className={`flex gap-x-[5px] mb-[3px] leading-[15.62px]`}
                        >
                          <p className="text-xs uppercase font-bold text-txtSecondary">
                            transaction type
                          </p>
                          <CustomTooltip
                            maxwidth="430px"
                            place="top"
                            id={`transaction-type-anchor`}
                            content={`<div class="text-xs leading-[18px] font-normal max-w-[200px]">You can either enter an amount or select a percentage of the total amount for each transaction.</div>`}
                          >
                            <InfoIcon
                              id={`transaction-type-anchor`}
                              strokeColor="var(--color-icon-bright)"
                              className="cursor-pointer group"
                              _className="group-hover:!stroke-iconObscure"
                            />
                          </CustomTooltip>
                        </div>
                        <div className="h-[40px]">
                          <TabsComp
                            totalTabs={ScheduleAmountTabs}
                            selected={selected}
                            setSelected={(val: any) => {
                              if (makePayment) {
                                const tmp = { ...data.paymentPlan };
                                tmp.transaction_type = val.value;
                                if (val.value !== selected.value) {
                                  let updatedTransArr =
                                    tmp.transactions?.map((item: any) => ({
                                      ...item,
                                      amount: 0,
                                    })) || [];
                                  tmp.transactions = updatedTransArr;
                                  tmp.percentage_amounts = [];
                                }
                                setData({ ...data, paymentPlan: tmp });
                                setIsApiCall(true);
                              }
                            }}
                            isInfo
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="w-full">
                        <div
                          className={`flex gap-x-[5px]  mb-[3px] items-center leading-[15.62px]`}
                        >
                          <p className="text-xs uppercase font-bold text-txtSecondary">
                            transaction amount
                          </p>
                          <CustomTooltip
                            maxwidth="430px"
                            place="top"
                            id={`transaction-amount-anchor`}
                            content={`<div class="text-xs leading-[18px] font-normal max-w-[410px]">${
                              data.paymentPlan?.schedule_amount === "fixed"
                                ? "Define a fixed amount per transaction."
                                : "The amount shown is automatically calculated by dividing the customer’s current balance by the total number of transactions. To change the transaction amount, select ‘Fixed’ or ‘Custom’."
                            }</div>`}
                          >
                            <InfoIcon
                              id={`transaction-amount-anchor`}
                              strokeColor="var(--color-icon-bright)"
                              className="cursor-pointer group"
                              _className="group-hover:!stroke-iconObscure"
                            />
                          </CustomTooltip>
                        </div>
                        <div
                          className={`relative ${
                            data.agreementType === "present"
                              ? "pointer-events-none"
                              : "pointer-events-auto"
                          }`}
                        >
                          <CustomAmountInput
                            inputValue={
                              data?.paymentPlan.schedule_amount === "auto"
                                ? data?.paymentPlan?.transactions?.[0]?.amount
                                : data?.paymentPlan?.amount
                            }
                            readOnly={isSelectedOffer}
                            aria-readonly={isSelectedOffer}
                            aria-label={
                              isSelectedOffer
                                ? "Transaction amount, set by selected offer"
                                : "Transaction amount"
                            }
                            disabled={
                              !isSelectedOffer &&
                              data?.paymentPlan?.schedule_amount === "auto"
                            }
                            setinputValue={(
                              val: any,
                              validationError?: string | null
                            ) => {
                              if (isSelectedOffer) return;
                              onScheduleAmountChange();
                              const tmp = { ...data.paymentPlan };
                              tmp.amount = val;
                              setData({ ...data, paymentPlan: tmp });
                              if (validationError) {
                                handleDebouncedChange(false);
                                return;
                              }
                              handleDebouncedChange();
                            }}
                            balance={
                              amountLimitBalance ??
                              userData?.data?.accountData?.balance
                            }
                            setErr={setAmtErr}
                            className={`!pl-[23px] ${
                              isSelectedOffer
                                ? "!bg-bgThird cursor-not-allowed"
                                : ""
                            }`}
                            showErr={false}
                            checkAmt={true}
                            allowOutOfRange={true}
                            validateOnChange={true}
                          />
                          {displayedAmountError && (
                            <p
                              className="text-red text-xs leading-[18.23px] w-full break-words"
                              role="alert"
                            >
                              {displayedAmountError}
                            </p>
                          )}
                          {isSelectedOffer && !displayedAmountError && (
                            <p className="text-txtSecondary text-xs leading-[18.23px] mt-1">
                              Amount set by the selected offer.
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <CustomTable1
                    dataArr={data?.paymentPlan?.transactions}
                    amountType={selected?.value || "amount"}
                    isExpanded={isTableExpanded}
                    setIsExpanded={setIsTableExpanded}
                    isDateCustom={data.paymentPlan?.schedule_fld === "custom"}
                    isCustom={
                      data.paymentPlan?.schedule_amount?.toLowerCase() ===
                      "custom"
                        ? true
                        : false
                    }
                    isSettlementEnable={data?.isOfferEnabled}
                    totalAmount={data.paymentPlan?.amount_subtotal}
                    grandTotal={data.paymentPlan?.grand_total}
                    addNewRow={addNewRow}
                    removeRow={removeRow}
                    handleChange={handleChange}
                    handleSave={handleSave}
                    isLoading={isLoading}
                    isdisplayFeeColumn={false}
                    makePayment={makePayment}
                    data={data}
                    amtErr={displayedAmountError}
                    amountLimitBalance={amountLimitBalance}
                    getStartLimit={getEndLimit}
                    isStartDateError={isStartDateError}
                    startDateErr={startDateErr}
                    dateErrMsg={dateErrMsg}
                    isEndDateError={isEndDateError}
                    setIsStartDateError={setIsStartDateError}
                    setDateErrMsg={setDateErrMsg}
                  />
                </>
              )}
              {currentStep === 2 && (
                <>
                  <SchedulePaymentComp
                    currentStep={2}
                    handlePrev={handlePrev}
                    schedulePayment={true}
                    dataArr={data?.paymentPlan}
                    handleGooglePay={handleGooglePayPayment}
                    createPayPalIntent={createPayPalIntent}
                    isGoogleLoading={isGoogleLoading}
                    paymentMethodList={paymentMethodList}
                    setSavedCardsEmail={setSavedCardsEmail}
                    dataPayment={dataPayment}
                    setDataPayment={setDataPayment}
                    walletList={oldWalletList}
                    isDataLoading={isDataLoading}
                    setCurrentStep={setCurrentStep}
                    setIsAddNewCard={setIsAddNewCard}
                    isAddNewCard={isAddNewCard}
                    setIsConfirmButtonDisable={setIsConfirmButtonDisable}
                    handleApplePay={handleApplePayPayment}
                    setShowPreview={setShowPreview}
                    setHideButtons={setHideButtons}
                    cashAppRef={cashAppRef}
                    bankRef={bankRef}
                    cardRef={cardRef}
                    selectedMethod={selectedMethod}
                    setSelectedMethod={setSelectedMethod}
                    amazonRef={amazonRef}
                    handlePlaidBankPayment={handlePlaidBankPayment}
                    isManualForm={isManualForm}
                    setIsManualForm={setIsManualForm}
                    setScheduleMethod={setScheduleMethod}
                    setFailedReason={setFailedReason}
                    setPaymentProcess={setPaymentProcess}
                    setAmount={setAmount}
                    sendEmail={sendEmail}
                    setScheduleDate={setScheduleDate}
                    setInvoiceId={setInvoiceId}
                    activeOffer={activeOffer}
                    vdcId={vdcId}
                  />
                </>
              )}
            </div>
          </div>
        )}
      </div>
      <div
        ref={disclosureContainerRef}
        className={`h-full lg:max-h-[var(--shell-vh)] relative content w-full lg:p-0 p-5 lg:pb-5 ${
          !showFinalDisclosure ? `hidden none` : ""
        }`}
        style={{ scrollMarginTop: "84px" }}
      >
        <DisclosureFinal
          generalMarkers={generalMarkers}
          handleAccept={handleAccept}
          isOpen={showFinalDisclosure}
        />
      </div>

      <CustomModal
        signModal={false}
        isLoading={false}
        isOpen={isDuplicateOrders && duplicateOrdersCount > 0}
        title="Alert"
        doneText="Complete Payment"
        className="max-w-[600px] w-full h-fit rounded-[10px]"
        cancleText="Cancel"
        onDoneClick={() => {
          dispatch(resetDuplicateOrder());
          handleAccept();
        }}
        onCloseClick={() => {
          dispatch(resetCheckDuplicatePayment());
          dispatch(resetDuplicateOrder());
        }}
        children={
          <React.Fragment>
            <div className="pt-5 lg:text-xl text-txtPrimary lg:leading-[30px] leading-[24px]">
              A similar payment was made in the last 10 minutes. Click 'Complete
              Payment' if this is not a duplicate.
            </div>
          </React.Fragment>
        }
      />
      <CustomModal
        signModal={false}
        isLoading={false}
        isOpen={showOverPaymentOverlay}
        title="Alert"
        doneText="Proceed"
        className="max-w-[600px] w-full h-fit rounded-[10px]"
        cancleText="Cancel"
        hasDoneButton={
          portalSettings?.overpayment_protection ===
          OverPaymentProtectionEnum.ALERT
        }
        onDoneClick={() => {
          dispatch(updateShowOverlayState(false));
          handleAccept();
        }}
        onCloseClick={() => {
          dispatch(updateCheckAmountState(false));
          dispatch(updateShowOverlayState(false));
        }}
        children={
          <React.Fragment>
            <div className="pt-5 lg:text-xl text-txtPrimary lg:leading-[30px] leading-[24px]">
              Processing this payment will result in a negative balance on your
              account. Please review the payment amount.
            </div>
          </React.Fragment>
        }
      />
    </>
  );
};

export default SchedulePayment;
